import React, { useCallback, useRef } from 'react';

import './convenientInvestments.scss';
import { useTranslation } from 'react-i18next';
import {
  CheckHandImage,
  GrayEllipseImage,
  HandPhoneImage,
  LetterShieldImage,
  SocialImage,
  WhiteEllipseImage,
} from 'src/assets';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const ConvenientInvestments = () => {
  const { t } = useTranslation();

  const renderItem = useCallback((image, title, subTitle) => {
    return (
      <div className="convenient-investments-item">
        <img className="convenient-investments-item-image" src={image} alt={image} />
        <div>
          <h3 className="convenient-investments-item-title">{title}</h3>
          <div className="convenient-investments-item-subtitle">{subTitle}</div>
        </div>
      </div>
    );
  }, []);

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  return (
    <div className="convenient-investments">
      <div
        className={`convenient-investments-content ${isVisible ? 'active-animation' : ''}`}
        ref={ref}
      >
        <div className="convenient-investments-section">
          <h1>
            {t('convenientInvestments:convinient')}{' '}
            <black-underline>{t('convenientInvestments:investment')}</black-underline>{' '}
            {t('convenientInvestments:platform')}
          </h1>
          <div>
            {renderItem(
              SocialImage,
              t('convenientInvestments:expert'),
              t('convenientInvestments:expertSub'),
            )}
            {renderItem(
              CheckHandImage,
              t('convenientInvestments:easy'),
              t('convenientInvestments:easySub'),
            )}
            {renderItem(
              LetterShieldImage,
              t('convenientInvestments:clear'),
              t('convenientInvestments:clearSub'),
            )}
          </div>
        </div>

        <img className="convenient-investments-image" src={HandPhoneImage} alt={HandPhoneImage} />
        <img
          className="convenient-investments-ellipse1"
          src={WhiteEllipseImage}
          alt={WhiteEllipseImage}
        />
        <img
          className="convenient-investments-ellipse2"
          src={WhiteEllipseImage}
          alt={WhiteEllipseImage}
        />
        <img
          className="convenient-investments-ellipse3"
          src={GrayEllipseImage}
          alt={GrayEllipseImage}
        />
      </div>
    </div>
  );
};
